import React, { useRef } from 'react';
import DocumentUploadPage from './DocumentUploadPage';
import DocumentListPage, { DocumentListPageRef } from './DocumentListPage';

/**
 * Documents page — combines DocumentUpload and DocumentList components.
 *
 * Task 24.1 adds the DocumentUpload component.
 * Task 24.2 adds the DocumentList component.
 * 
 * Auto-refreshes document list after successful upload.
 */
const DocumentsPage: React.FC = () => {
  const documentListRef = useRef<DocumentListPageRef>(null);

  const handleUploadSuccess = () => {
    documentListRef.current?.refresh();
  };

  return (
    <div className="documents-page">
      <DocumentUploadPage onUploadSuccess={handleUploadSuccess} />
      <DocumentListPage ref={documentListRef} />
    </div>
  );
};

export default DocumentsPage;
